// extracted by mini-css-extract-plugin
export default {"title":"index_title_hLVxQ","box":"index_box_SQS0t clearfix"};